export default "__VITE_ASSET__ZzJrAhX0__"